import schema from './editorSchema';

export const options = {
  history: true,
  keyboardShortcuts: true,
  inputRules: true,
  schema: schema,
};
